import { Component, OnInit,Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HomepageService } from '../../../services/homepage.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DatepickerOptions } from 'ng2-datepicker';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { getYear } from 'date-fns';
import locale from 'date-fns/locale/en-US';
import { TenantService } from '../../../services/tenant.service';


@Component({
  selector: 'app-bulletin-detail',
  templateUrl: './bulletin-detail.component.html',
  styleUrls: ['./bulletin-detail.component.css']
})
export class BulletinDetailComponent implements OnInit {
  responseAPIstatus: boolean = true;
  constructor(@Inject(DOCUMENT) private document: Document, private homepageService : HomepageService,private activatedRoute: ActivatedRoute, private cookieService : CookieService, private router : Router, private tenantService: TenantService) {
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      this.optionsEditor.requestHeaders.Authorization = 'Bearer '+localStorage.getItem('token');    
    }
    this.optionsEditor.requestHeaders.tenant = this.tenantService.tenant;
    this.optionsEditor.requestHeaders.configuration = this.tenantService.configurationSetting;
    }
    tetent: any = '';
    confiGurationSetting: any = '*';
    token: any = ''; 
    bulletinDetail :any = [];
    canEdit : boolean = false;
    loations: any = [];
    showDate: boolean = false;
    saveBulletin: boolean = false;
    date:  any =  new Date();;
    showDeleteConfirm: boolean = false;
    deleteBulletinId: number = 0;
    deleteBulletinEvent: any = null;
    public optionsEditor: any = {
      key: '6LF5g1D4A3B2B5D5E4F-11SLJCKHXOSLMc1YGSGb1ZXHSe1CgB5A4D4A3E3C2A13A19B6C6==',  
      toolbarInline: false,
      attribution:false,
      fileUpload: false,
      toolbarVisibleWithoutSelection: true,
      imageStyles: {
        class1: 'Class 1',
        class2: 'Class 2'
      },
      imageUploadMethod: 'post',
      requestHeaders: {
        tenant: '', 
        configuration : this.confiGurationSetting,
        Authorization:''
      },
      imageUploadURL: 'https://api.library.site/v1/bulletin/bulletinimage/upload',  
      events: {
        'image.uploaded': function (response) {
          var img_url = JSON.parse(response).data.url;
          this.image.insert(img_url, false, null, this.image.get(), response);       
          return false;
        }
      },
      toolbarButtons: {
        moreText: { buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'] },
        moreParagraph: { buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'] },
        moreRich: { buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR'] },
        moreMisc: { buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'], align: 'right', buttonsVisible: 2 }
      },
      imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize']
    };
    options: DatepickerOptions = {
    minYear: 1970, // minimum available and selectable year
    maxYear: 2030, // maximum available and selectable year
    placeholder: '', // placeholder in case date model is null | undefined, example: 'Please pick a date'
    format: 'MM-dd-yyyy', // date format to display in input
    formatTitle: 'MM yyyy',
    formatDays: 'EEEEE',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale, // date-fns locale
    position: 'bottom',
    inputClass: '', // custom input CSS class to be applied
    calendarClass: 'datepicker-default', // custom datepicker calendar CSS class to be applied
    scrollBarColor: '#dfe3e9', // in case you customize you theme, here you define scroll bar color
   //keyboardEvents: true // enable keyboard events
    };
    ngOnInit() {
    	this.document.body.classList.add('inner-page');
    	this.document.body.classList.remove('list');
    	if(typeof(this.activatedRoute.snapshot.paramMap.get("bulletin_id")) != 'undefined' && this.activatedRoute.snapshot.paramMap.get("bulletin_id")){
    		this.getBulletin(this.activatedRoute.snapshot.paramMap.get("bulletin_id"));
    	}
      //checking for patron login or not.
      if(this.cookieService.check('patron')){
        //user can edit only if patron has permission.
        var permissions = JSON.parse(this.cookieService.get('patronPermissions'));
        this.canEdit = permissions.opacAdmin;
      } else {
        this.canEdit = false;
      }
      this.homepageService.getConfig().subscribe((data:any) => {
        var tnt = data.data.tenantCode.toLowerCase();
        var slctloc = this.cookieService.get('selectedlocation'+tnt);
        var locData = {};
        data.data.settings.location.locations.forEach((loc) => {
          if(loc.id == slctloc){
            locData = {'id' : loc.id, 'name' : loc.name};
          }
        });
       this.loations = locData;
      });
    }

    //To get single bulletin
    getBulletin(id){
      return this.homepageService.getBulletinDetail(id).subscribe((data:any) => {
        this.bulletinDetail = data;
        this.date = this.bulletinDetail.data.date;
        if(this.date){
          let newDate = new Date(this.date);
          let datePipe = new DatePipe('en-US');
          let editDate = datePipe.transform(newDate, 'MM-dd-yyyy'); // 02.08.2023
          this.date = new Date(editDate);
          this.showDate = true;
        } else {
          this.date = new Date(Date.now());
        }
        this.homepageService.updateBannerText(this.bulletinDetail.data.caption);
        this.responseAPIstatus = false;
      });
    }

  showDeleteConfirmation(id, event) {
    this.showDeleteConfirm = true;
    this.deleteBulletinId = id;
    this.deleteBulletinEvent = event;
  }

  hideDeleteConfirmation() {
    this.showDeleteConfirm = false;
  }

    //delete bulletin
    deleteBulletin(){
      var self = this;
      this.showDeleteConfirm = false;
      this.deleteBulletinEvent.preventDefault();
        var token = localStorage.getItem('token');
        self.homepageService.getBulletDelete(this.deleteBulletinId, token).subscribe((data: any) => {
          if(data.status === true){
            this.router.navigate(['/bulletins']);
          }
        });
    }

    //To show date box.
    showDateInput(event){
      if(this.showDate === true){
        this.showDate = false;
      } else {
        this.showDate = true;
      }
    }

    //To save type( or method or setting) of bulletin.
    saveBulletinMethod(event){
      this.saveBulletin = true;
      var bid =   $.trim($('#bid').val().toString());
      var bHeadline = $.trim($('#bHeadline').val().toString());
      var bcontent = $.trim($('#bContent').val().toString());
      var bLocation = $.trim($('input[name="selectlocation"]:checked').val().toString());
      if(bLocation == '' || bLocation == null){
        bLocation = null;
        let loc: string = sessionStorage.getItem('lastSearchLocation');
        bLocation =  loc;
      }
      let bDate:any = null;
      if($('#bIsDate').is(':checked')){
        bDate = $.trim($('#bDate').find('input').val().toString());
        let newDate = new Date(bDate);
        let datePipe = new DatePipe('en-US');
        this.date = datePipe.transform(newDate, 'MM-dd-yyyy'); // 02.08.2023
        bDate = this.date;
      }
     let newdate = $.trim($('#bDate').find('input').val().toString());
      var token = localStorage.getItem('token');
      this.homepageService.editBulletin(bid,bHeadline, bcontent, bLocation,bDate, token).subscribe((data:any) => {
        this.saveBulletin = false;
        this.bulletinDetail = data;
        if(this.bulletinDetail.data.date){
          this.showDate = true;
        }
        this.responseAPIstatus = false;
        $('#closeBulletinAdd').trigger('click');
      });
    }
  }
